import {deliveryMethodTypes, deliveryTypes} from 'app/constant'
import {FC} from 'react'

type Props = {
  orderDeliveryMethod: any
  onHandleChange: (value: any) => void
  onHandleEditRate: (value: any) => void
}

export const OrderDeliveryMethodChange: FC<Props> = ({
  orderDeliveryMethod,
  onHandleChange,
  onHandleEditRate,
}) => {
  const handleDeliveryChange = (e: any) => {
    const {value: orderDeliveryMethod} = e.target
    if (onHandleChange) {
      onHandleChange(orderDeliveryMethod)
    }
  }

  return (
    <div className=' d-flex gap-6 mt-5 col'>
      <select
        className='form-select w-75'
        name='deliveryType'
        onChange={handleDeliveryChange}
        value={orderDeliveryMethod}
      >
        {deliveryMethodTypes.map((delivery, index) => (
          <option key={index} value={delivery.value}>
            {delivery.name}
          </option>
        ))}
      </select>
      <button
        id='btnEdit'
        className='btn explore-btn-outline w-auto btn-sm text-no-wrap'
        disabled={orderDeliveryMethod === deliveryTypes.pickup}
        onClick={onHandleEditRate}
      >
        Edit Rate
      </button>
    </div>
  )
}
export default OrderDeliveryMethodChange
